module.exports = "<span (click)=\"toggle('list')\" class=\"c-sort-view__item\" [class.c-sort-view__item--active]=\"isListViewActive\"><i class=\"icon__n icon__n--list\"></i></span>\n<span (click)=\"toggle('card')\" class=\"c-sort-view__item c-sort-view__item__box\" [class.c-sort-view__item--active]=\"isCardViewActive\"><i class=\"icon__n icon__n--grid\"></i></span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/sort-view/sort-view.component.html
// module id = ./src/app/modules/common-module/components/sort-view/sort-view.component.html
// module chunks = 9